
import en from "./en-ca-locale.js";
import ja from "./ja-jp-locale.js";
import es from "./es-ar-locale.js";
// import zh from "./zh-cn-locale.js";


export const getMessages = (locale) => {
    switch (locale) {
        // case 'ja-JP':
        // case 'ja':
        //     return ja;
        // case 'zh-CN':
        // case 'zh':
        //     return zh;
        case 'es-AR':
        case 'es-CL':
        case 'es-419':
        case 'es-CO':
        case 'es-CR':
        case 'es-HN':
        case 'es-MX':
        case 'es-PE':
        case 'es-ES':
        case 'es-US':
        case 'es-UY':
        case 'es-VE':
        case 'es':
            return es;
        default:
            return es;
    }
}

// export const getSupportedLocale = (locale) => {
//     let supportedLocales = ['en-CA', 'en', 'ja-JP', 'ja', 'zh-CN', 'zh'];
//     if (supportedLocales.includes(locale)) {
//         return locale;
//     }
//     return 'en-CA'
// }

export const getSupportedLocale = (locale) => {
    console.log(locale)
    switch (locale) {
        // case 'ja-JP':
        // case 'ja':
        //     return 'ja';
        // case 'zh-CN':
        // case 'zh':
        //     return 'zh-CN';
        case 'es-AR':
        case 'es-CL':
        case 'es-419':
        case 'es-CO':
        case 'es-CR':
        case 'es-HN':
        case 'es-MX':
        case 'es-PE':
        case 'es-ES':
        case 'es-US':
        case 'es-UY':
        case 'es-VE':
        case 'es':
            return 'es';
        default:
            return 'es';
    }
}